import { createContext, useContext } from "react";

// Lets a preview frame host overlays inside itself instead of the page.
export const OverlayHostContext = createContext(null);
export const useOverlayHost = () => useContext(OverlayHostContext);
